export default {
  brand: "A&A MOTORS",
  tagline: "EVERY DRIVE. EVERY LIFESTYLE.",
  slogan: "ALL CARS. ALL STYLES. ONE NAME.",
  nav: {
    fleet: "Fleet",
    noDeposit: "No Deposit",
    how: "How It Works",
    about: "About",
    faq: "FAQ",
    contact: "Contact",
    book: "Book Your Car",
    menu: "Menu",
    close: "Close",
  },
  hero: {
    eyebrow: "Car Rental Dubai",
    line1: "EVERY DRIVE.",
    line2: "EVERY LIFESTYLE.",
    sub: "From everyday drives to extraordinary experiences.",
    ctaFleet: "Explore Our Fleet",
    ctaBook: "Book Your Car",
    scroll: "Scroll",
  },
  categories: {
    all: "All Vehicles",
    economy: "Economy Cars",
    everyday: "Everyday Cars",
    sedans: "Sedans",
    suv: "SUVs",
    luxury: "Luxury Cars",
    sports: "Sports Cars",
    supercars: "Supercars",
  },
  fleet: {
    eyebrow: "The Collection",
    title: "Our Fleet",
    sub: "Our current collection — more vehicles are being added. Availability and prices are confirmed on enquiry.",
    priceOnRequest: "Price on request",
    perDay: "/ day",
    seats: "Seats",
    transmission: "Transmission",
    viewDetails: "View Details",
    enquire: "Enquire Now",
    noDeposit: "No-deposit option",
    onRequest: "On request",
    available: "Available",
    unavailable: "Unavailable",
    sort: "Sort by",
    sortFeatured: "Featured",
    sortName: "Name A–Z",
    sortPriceAsc: "Price: low to high",
    sortPriceDesc: "Price: high to low",
    noDepositOnly: "No-deposit eligible",
    showAll: "Show all vehicles",
    noResults: "No vehicles match this filter.",
    sampleNote: "Availability, specifications and final pricing are always confirmed by our team before booking.",
    loading: "Loading the fleet…",
    loadError: "The fleet could not be loaded. Please try again.",
    retry: "Retry",
  },
  modal: {
    specs: "Specifications",
    engine: "Engine",
    acceleration: "0–100 km/h",
    perDay: "per day",
    finalNote: "Final price and availability are confirmed on enquiry.",
    noDepositYes: "Eligible for no-deposit rental (conditions apply)",
    enquireVehicle: "Enquire About This Car",
    whatsapp: "WhatsApp Us",
    close: "Close",
    drag: "Drag to rotate",
    gallery: "Gallery",
    view360: "360° View",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    availability: "Availability",
    previous: "Previous image",
    next: "Next image",
  },
  nodeposit: {
    eyebrow: "Flexible Rentals",
    title: "NO DEPOSIT OPTIONS AVAILABLE",
    text: "Enjoy a more flexible rental experience in Dubai. No-deposit options apply to selected vehicles and are subject to conditions such as rental duration and driver profile.",
    cta: "Explore Eligible Vehicles",
    note: "Applies to selected vehicles only. Eligibility and terms are confirmed during your enquiry.",
  },
  how: {
    eyebrow: "The Process",
    title: "How It Works",
    steps: [
      { t: "Choose Your Car", d: "Explore our selection, from everyday vehicles to luxury cars and supercars." },
      { t: "Send Your Enquiry", d: "Tell us your preferred vehicle and rental dates." },
      { t: "Confirm Your Booking", d: "Our team confirms availability, pricing, requirements, and the next steps." },
    ],
  },
  about: {
    eyebrow: "About A&A MOTORS",
    title1: "MORE THAN A CAR.",
    title2: "IT'S YOUR LIFESTYLE.",
    p1: "At A&A MOTORS, we believe every journey deserves the right car.",
    p2: "Whether you're exploring Dubai, travelling for business, looking for a comfortable everyday vehicle, or ready to experience a performance car, our vision is to make finding your next drive simple and flexible.",
    p3: "From everyday essentials to extraordinary automotive experiences, we're building a brand around choice, service, and the freedom to drive your way.",
  },
  trust: {
    eyebrow: "Trust & Transparency",
    title: "Rent With Confidence",
    items: [
      { t: "Clear Rental Conditions", d: "Every condition is shared in writing before you confirm anything." },
      { t: "Transparent Pricing", d: "No hidden fees — final pricing is confirmed during your enquiry." },
      { t: "Vehicle-Specific Deposits", d: "Deposit and no-deposit options depend on the vehicle you choose." },
      { t: "Responsive Support", d: "Reach us directly on WhatsApp or by phone, in your language." },
      { t: "Straightforward Enquiries", d: "One form or one message — our team handles the rest." },
    ],
  },
  faq: {
    eyebrow: "Good To Know",
    title: "Frequently Asked Questions",
    items: [
      {
        q: "What documents do I need to rent a car in Dubai?",
        a: "Typically a valid driving licence, a passport or Emirates ID, and a payment card. Tourists may also need an International Driving Permit depending on their home licence. Exact requirements depend on the vehicle and your residency status — our team confirms everything before booking.",
      },
      {
        q: "Is a passport required?",
        a: "Tourists are generally asked for a passport with an entry stamp or visa, while UAE residents use their Emirates ID. Requirements vary, and we confirm them for your specific booking.",
      },
      {
        q: "Is a valid driving licence required?",
        a: "Yes, always. Depending on the issuing country, an International Driving Permit may also be required. Some high-performance vehicles carry minimum age or licence-history conditions.",
      },
      {
        q: "Are no-deposit rental options available?",
        a: "Yes, on selected vehicles and under specific conditions. Eligibility depends on the vehicle, rental duration and driver profile — contact us to check a specific car.",
      },
      {
        q: "Can I rent a car for one day?",
        a: "Yes, daily rentals are available on many vehicles. Minimum rental periods can apply to certain models.",
      },
      {
        q: "Can I request delivery to my hotel?",
        a: "Delivery within Dubai — to your hotel, residence or the airport — can be arranged on request, subject to the vehicle and scheduling.",
      },
      {
        q: "How do I check vehicle availability?",
        a: "Send an enquiry via the form or WhatsApp with your preferred dates. Our team confirms availability and final pricing before any booking is made.",
      },
      {
        q: "What are the rental and insurance conditions?",
        a: "Basic insurance is typically included. Excess amounts, mileage limits, fuel and Salik (toll) policies vary by vehicle. All conditions are shared transparently before you confirm.",
      },
    ],
  },
  form: {
    eyebrow: "Booking Enquiry",
    title: "Request a Booking",
    sub: "Tell us what you'd like to drive and when. Our team replies with availability, exact pricing and requirements.",
    name: "Full name",
    email: "Email address",
    phone: "Phone number",
    method: "Preferred contact method",
    methodWhatsapp: "WhatsApp",
    methodCall: "Phone call",
    methodEmail: "Email",
    vehicle: "Vehicle of interest",
    vehicleAny: "Any vehicle / advise me",
    pickup: "Pickup date",
    return: "Return date",
    handover: "Pickup or delivery",
    handoverPickup: "I'll pick up the car",
    handoverDelivery: "Deliver to me (hotel / residence / airport)",
    message: "Additional message",
    messagePh: "Flight details, delivery address, questions…",
    submit: "Request a Booking",
    sending: "Sending…",
    success: "Your enquiry is ready — WhatsApp just opened with all the details. Simply press send, and we'll reply shortly.",
    whatsappNote: "Submitting opens WhatsApp with your enquiry — the fastest way to reach us.",
    error: "Something went wrong while sending your enquiry. Please try again or contact us on WhatsApp.",
    errRequired: "This field is required",
    errEmail: "Please enter a valid email address",
    errDates: "Return date must be on or after the pickup date",
  },
  contact: {
    eyebrow: "Contact",
    title: "Talk To Us Directly",
    text: "The fastest way to check availability and prices. We answer on WhatsApp and by phone.",
    whatsapp: "WhatsApp Us",
    whatsappAlt: "WhatsApp — 2nd line",
    callUs: "Call Us",
    uae: "UAE",
    germany: "Germany",
    uaeNote: "Phone calls",
    germanyNote: "WhatsApp & phone calls",
    copy: "Copy",
    copied: "Copied",
  },
  floating: {
    open: "Contact options",
    whatsapp: "WhatsApp Us",
    whatsappAlt: "WhatsApp (2nd line)",
    callUae: "Call UAE",
    callDe: "Call Germany",
  },
  footer: {
    desc: "Premium car rental in Dubai — from everyday drives to extraordinary experiences.",
    fleetTitle: "Fleet",
    contactTitle: "Contact",
    legalTitle: "Legal",
    socialTitle: "Follow Us",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    cookies: "Cookie Settings",
    impressum: "Legal Notice",
    rights: "All rights reserved.",
    socialPlaceholder: "Official profiles launching soon",
  },
  cookies: {
    text: "We use essential storage to remember your language preference and privacy-conscious analytics to improve this website. No advertising cookies.",
    accept: "Accept",
    decline: "Decline",
  },
  legal: {
    privacyTitle: "Privacy Policy",
    termsTitle: "Terms & Conditions",
    impressumTitle: "Legal Notice / Impressum",
    backHome: "Back to homepage",
    impressumNote: "Legal information for the A&A MOTORS website. Fields marked [to be provided] will be completed once the official registration documents are available.",
    impressumFields: [
      "Brand / company name: A&A MOTORS",
      "Founders / Legal representatives: Abadellh Aiouze · Amin Schmidt",
      "Location: Dubai, United Arab Emirates — full registered address: [to be provided]",
      "Trade licence number: [to be provided]",
      "VAT / TRN: [to be provided]",
      "Responsible for content (§ 55 Abs. 2 RStV): Abadellh Aiouze · Amin Schmidt",
    ],
    privacySections: [
      { h: "Data We Collect", p: "When you send a booking enquiry we process the details you provide — name, email, phone number, preferred vehicle and rental dates — solely to respond to your enquiry." },
      { h: "How We Use It", p: "Your data is used only to process your enquiry and, if a rental follows, to prepare the rental agreement. We do not sell or share your data with third parties for marketing." },
      { h: "Storage & Retention", p: "Enquiries are stored securely and retained only as long as needed to handle your request and meet legal obligations." },
      { h: "Your Rights", p: "You may request access, correction or deletion of your personal data at any time by contacting us via WhatsApp or phone." },
    ],
    termsSections: [
      { h: "General", p: "These terms govern the use of the A&A MOTORS website. Vehicles, availability and prices shown are sample content until confirmed in an individual rental agreement." },
      { h: "Enquiries & Bookings", p: "Submitting an enquiry does not create a booking. A rental contract is formed only after our team confirms availability, pricing and requirements with you." },
      { h: "Vehicles & Pricing", p: "Displayed vehicles, specifications and prices are illustrative. Final terms — including deposits, insurance, mileage and Salik tolls — are communicated before booking." },
      { h: "Liability", p: "We strive for accuracy but cannot guarantee that all website content is complete or current at all times." },
    ],
  },
  admin: {
    login: "Admin Login",
    email: "Email",
    password: "Password",
    signIn: "Sign In",
    signingIn: "Signing in…",
    loginError: "Invalid credentials or too many attempts.",
    dashboard: "Fleet Dashboard",
    vehicles: "Vehicles",
    enquiries: "Enquiries",
    logout: "Log out",
    addVehicle: "Add Vehicle",
    edit: "Edit",
    del: "Delete",
    save: "Save",
    cancel: "Cancel",
    name: "Name",
    category: "Category",
    price: "Price / day (AED, empty = on request)",
    seats: "Seats",
    transmission: "Transmission",
    availability: "Availability",
    noDeposit: "No-deposit eligible",
    image: "Image URL",
    featured: "Featured",
    status: "Status",
    empty: "No enquiries yet.",
    confirmDelete: "Delete this vehicle?",
    dates: "Dates",
    message: "Message",
    back: "Back to website",
    vehicleSaved: "Vehicle saved",
    vehicleDeleted: "Vehicle deleted",
    statusUpdated: "Status updated",
    newVehicle: "New vehicle",
    editVehicle: "Edit vehicle",
  },
};
